import { createContext, useContext } from 'react';
import { TreeEntry, TreePath } from './types';
import { UseTreeRoverProps } from './hooks/useTreeRover';

export interface TreeContextData {
  expandedIds: Set<string>;
  selectedIds: Set<string>;
  checkedIds: Set<string>;
  checkable: boolean;
  shouldExpandOnSelect: boolean;
  onSelect: (item: TreeEntry, path: TreePath) => void;
  onExpand: (item: TreeEntry, path: TreePath) => void;
  onCheck: (item: TreeEntry, checked: boolean) => void;
  getCheckState: (item: TreeEntry) => { checked: boolean; indeterminate: boolean };
  getRoverItemProps(item: TreeEntry, path: TreeEntry[]): UseTreeRoverProps;
}

export const TreeContext = createContext<TreeContextData | null>(null);

export function useTreeContext(): TreeContextData {
  const context = useContext(TreeContext);
  if (context == null) {
    throw new Error('TreeContext is null');
  }
  return context;
}
